import { myStyleDark, myStyleLight } from "../dist/helpers";
import {
  MailOutlined,
  PhoneOutlined,
  ClockCircleOutlined,
} from "@ant-design/icons";

const contactItems = [
  {
    icon: <MailOutlined />,
    iconBg: "rgba(59, 130, 246, 0.12)",
    iconColor: "#3b82f6",
    head: "Email",
    body: "dilks44@gmail.com",
    action: "mailto:dilks44@gmail.com",
    actionLabel: "Send an email",
  },
  {
    icon: <PhoneOutlined />,
    iconBg: "rgba(6, 182, 212, 0.12)",
    iconColor: "#06b6d4",
    head: "Call or Text",
    body: "(240) 446-1194",
    action: "tel:+12404461194",
    actionLabel: "Dial now",
  },
  {
    icon: <ClockCircleOutlined />,
    iconBg: "rgba(139, 92, 246, 0.12)",
    iconColor: "#8b5cf6",
    head: "Response Time",
    body: "Within one business day",
    action: null,
    actionLabel: null,
  },
];

export default function Contact({ finalIsDarkMode }) {
  const tc      = finalIsDarkMode ? "text-white" : "text-black";
  const mc      = finalIsDarkMode ? "text-white-50" : "text-muted";
  const surface = finalIsDarkMode ? myStyleDark : myStyleLight;
  const pageBg  = finalIsDarkMode
    ? { background: "#0d1526", minHeight: "100vh" }
    : { background: "#f1f5f9", minHeight: "100vh" };

  return (
    <div style={pageBg}>

      {/* ─── PAGE HERO ─────────────────────────────────────── */}
      <div
        className="page-hero"
        style={{ background: "linear-gradient(135deg, #0f766e 0%, #0891b2 50%, #1d4ed8 100%)" }}
      >
        <div style={{
          position: "absolute", top: "-30%", right: "-5%",
          width: 440, height: 440, borderRadius: "50%",
          background: "rgba(255,255,255,0.04)", pointerEvents: "none",
        }} />
        <div style={{
          position: "absolute", bottom: "-40%", left: "-5%",
          width: 320, height: 320, borderRadius: "50%",
          background: "rgba(255,255,255,0.03)", pointerEvents: "none",
        }} />
        <div className="container" style={{ position: "relative", zIndex: 1 }}>
          <span className="section-label" style={{ color: "#5eead4" }}>Get in touch</span>
          <h1 className="display-5 fw-bold text-white mb-3">Contact Us</h1>
          <p className="text-white-50 mb-0" style={{ fontSize: "1.1rem", maxWidth: 500, lineHeight: 1.7 }}>
            Ready to talk about your project? We'd love to hear from you —
            no obligation, just a focused conversation.
          </p>
        </div>
      </div>

      {/* ─── CONTACT CARDS ─────────────────────────────────── */}
      <div className="container py-5">
        <div className="row g-4 justify-content-center mb-5">
          {contactItems.map((item) => (
            <div key={item.head} className="col-md-4">
              <div className="h-100 p-4 rounded-3 card-hover text-center" style={surface}>

                <div
                  className="service-icon mx-auto"
                  style={{ background: item.iconBg, color: item.iconColor }}
                >
                  {item.icon}
                </div>

                <h4 className={`fw-bold mb-2 ${tc}`}>{item.head}</h4>
                <p className={`mb-3 ${mc}`} style={{ fontSize: "1.05rem" }}>{item.body}</p>

                {item.action && (
                  <a
                    href={item.action}
                    className="btn btn-outline-primary btn-sm"
                    style={{ borderRadius: 8 }}
                  >
                    {item.actionLabel} &rarr;
                  </a>
                )}

              </div>
            </div>
          ))}
        </div>

        {/* ─── CTA BANNER ──────────────────────────────────── */}
        <div className="cta-section text-center">
          <h2
            className="fw-bold text-white mb-3"
            style={{ position: "relative", zIndex: 1, fontSize: "1.85rem" }}
          >
            Let's start with a quick email
          </h2>
          <p
            className="text-white-50 mb-4"
            style={{
              position: "relative",
              zIndex: 1,
              maxWidth: 440,
              margin: "0 auto 28px",
              lineHeight: 1.7,
            }}
          >
            Tell us about your project and we'll get back to you within
            one business day.
          </p>
          <div style={{ position: "relative", zIndex: 1 }}>
            <a
              href="mailto:dilks44@gmail.com"
              className="btn btn-light btn-lg px-4"
              style={{ borderRadius: 10, fontWeight: 600, color: "#1e40af" }}
            >
              dilks44@gmail.com
            </a>
          </div>
        </div>

      </div>
    </div>
  );
}
